import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Agilysys logo mark SVG
export function AgilysysLogo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="216" height="216" viewBox="0 0 216 216" fill="none">
      <path d="M74.4996 199.1C114.7 199.1 147.4 166.5 147.4 126.2C147.4 85.9 114.8 53.3 74.4996 53.3C34.1996 53.3 1.59961 85.9 1.59961 126.2C1.59961 166.5 34.1996 199.1 74.4996 199.1Z" fill="#84BD00"/>
      <path d="M174.8 96.2C196.7 96.2 214.4 78.5 214.4 56.6C214.4 34.7 196.7 17 174.8 17C152.9 17 135.2 34.7 135.2 56.6C135.2 78.5 152.9 96.2 174.8 96.2Z" fill="#009CDE"/>
      <path d="M111.1 140.3C105.7 147 94.1998 153.7 80.4998 153.7C66.7998 153.7 54.2998 143.7 54.2998 128.2C54.2998 112.7 67.0998 102.9 86.9998 101.6C95.1998 101 103.3 100.8 110.7 100.8V96.8C110.7 81.3 104.4 71.9 89.2998 71.9C74.1998 71.9 72.2998 74.4 64.9998 78.4L60.9998 65.8C70.5998 60.1 80.4998 57.9 92.3998 57.9C114 57.9 128 71.7 128 96.4V151.7H111.1V140.2V140.3ZM110.7 129.2V112.2C103 112.6 96.4998 113.2 89.9998 113.9C79.2998 115 70.8998 118.3 70.8998 128.3C70.8998 138.3 76.2998 141.1 85.4998 141.1C94.6998 141.1 104.5 136.1 110.8 129.2H110.7Z" fill="white"/>
    </svg>
  );
}

// Green SVG divider line
export function GreenDivider() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1091" height="8" viewBox="0 0 1091 8" fill="none">
      <path d="M4 4H1087" stroke="#84BD00" strokeWidth="7" strokeLinecap="round"/>
    </svg>
  );
}

function FeaturedSolutions({ children }) {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div id="featured-solutions" className={`featured-solutions${visible ? ' slide-up' : ''}`}>
      <div className="header-box">Featured Solutions</div>
      <div className="left-side">
        <div className="row">
          <img src="/assets/higher-ed/solutions/integrations-icon.svg" alt="" className="integrations-icon" />
          <span>Plus integrations with{'\n'}existing solutions</span>
        </div>
        <div className="f-logo" onClick={() => navigate('/aboutus/agilysys')}>
          <img src="/assets/higher-ed/agilysys-wordmark.svg" alt="Agilysys" style={{width:'100%',height:'auto'}} />
        </div>
      </div>
      <div className="right-side">
        {children}
      </div>
    </div>
  );
}

export default FeaturedSolutions;
